<div class="video-wrapper">
    <div *ngIf="enableDebugLogging" class="status-bar">
        <strong>Status:</strong> {{ _statusText}}
    </div>

    <div #playerHost class="player-host"></div>
</div>